import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SessionService } from '@fi-app/utilities/fi-services/session.service';
import { AgreementService } from '../agreement.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { AgreementModel } from '@fi-shared/fi-agreement/agreement.model';
import { AppTextService } from '@fi-shared/app-text';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { FiContentLanguageSharedService } from '@fi-shared/fi-content-language-shared/fi-content-language-shared.service';
import { EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { AgreementPublishedContentModel } from '@fi-shared/fi-agreement/agreement-published-content.model';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Component({
    selector: 'fi-agreement-view-version',
    templateUrl: './agreement-view-version.component.html',
    styleUrls: ['./agreement-view-version.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-agreement-view-version' },
    standalone: false,
})
export class FiAgreementViewVersionComponent implements OnInit {
    @Input() agreement: AgreementModel;

    EditTabs: EditTabsModel;
    currentVersion;
    selectedVersion;
    activeVersion;
    publishedContent: AgreementPublishedContentModel;

    constructor(
        private sessionService: SessionService,
        private agreementService: AgreementService,
        private loadingService: LoadingService,
        private stateService: FiStateService,
        private appTextService: AppTextService,
        private contentLanguagesService: ContentLanguagesService,
        private userDataService: FiUserDataService,
        private contentLanguageSharedService: FiContentLanguageSharedService,
        private fiFormatDateService: FiFormatDateService,
    ) {}

    ngOnInit() {
        this.EditTabs = new EditTabsModel(this.getAgreementName());
        this.publishedContent = this.agreement.GetPublishedContentByContentLanguage(
            this.userDataService.userData.PreferredContentLanguage,
            this.contentLanguageSharedService.getDefaultContentLanguageId(),
        );
        this.currentVersion = this.agreement.GetVersion(
            this.publishedContent.AgreementVersion,
            this.publishedContent.ContentLanguageId,
        );
        this.selectedVersion = this.agreement.GetVersion(
            this.stateService.params.Version,
            this.publishedContent.ContentLanguageId,
        );
        this.activeVersion = this.currentVersion.AgreementVersion;

        // const sourceNode = $compile('<div>' + this.selectedVersion.Content + '</div>')($rootScope)[0],
        //     currentNode = $compile('<div>' + this.currentVersion.Content + '</div>')($rootScope)[0];
        // this.compareHtmlService.compareNodes(sourceNode, currentNode);
        // this.selectedVersion.Content = sourceNode.innerHTML;
        // this.currentVersion.Content = currentNode.innerHTML;
    }

    save() {
        const loading = this.loadingService.startLoading();
        this.agreementService
            .GenerateNewAgreementVersion(this.agreement.Id, this.activeVersion, this.publishedContent.ContentLanguageId)
            .then(() => {
                this.agreementService
                    .GetAgreement(this.agreement.Id)
                    .then((response) => {
                        this.agreement.InitializeAgreement(this.appTextService, this.fiFormatDateService, response);
                        loading();
                        this.stateService.go('Agreement.View');
                    })
                    .catch(loading);
            })
            .catch(loading);
    }

    private getAgreementName(): string {
        return this.agreementService.getAgreementName(this.agreement);
    }
}
